import { render } from "./Lectin.vue?vue&type=template&id=38c07b08"
import script from "./Lectin.vue?vue&type=script&lang=js"
export * from "./Lectin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__